<template>
  <div class="queries-tabs-container">
    <b-tabs>
      <b-tab :title="`Open Queries: ${noOfOpenQueries}`" :title-link-class="'tabs-details'">
        <!-- New Query -->
        <template v-if="isQueryInEditMode">
          <div class="field-query-container position-absolute">
            <div class="create-new-query-form-container">
              <b-form-textarea id="openQueryText" placeholder="Enter your comment" name="openQueryText" rows="9" no-resize v-model="openQueryText" :state="veeFields.openQueryText && veeFields.openQueryText.dirty ? !errors.has('openQueryText') : null" v-validate="'required'"></b-form-textarea>
              <div class="create-new-form-container__btns-container mt-20 pl-16">
                <button @click="postNewQuery" :disabled="isCreateQueryBtnDisabled" class="post-query-btn mr-16">Create Query</button>
                <button @click="cancelCreatingANewQuery" class="cancel-post-query-btn">Cancel</button>
              </div>
            </div>
          </div>
        </template>

        <!-- Display Open Queries -->
        <template v-else>
          <div class="filter-container d-flex justify-content-between p-7 fs-12" v-if="selectedQuestionId && !openQueryId">
            Filtered by field ID {{ selectedQuestionId }}
            <span class="clear-filter-text" @click="clearFilter">Clear</span>
          </div>
          <div v-if="openQueries && openQueries.length">
            <div class="partipant-response-open-queries-container queries-container">
              <div v-if="!openQueryId" class="pt-16">
                <ParticipantActivityResponseQueryItem v-for="query in openQueries" :key="query.id" :query="query" @displayDetailedView="viewOpenQueryDetails" />
              </div>

              <div v-else>
                <ParticipantActivityResponseQueryDetails :lockStatus="lockStatus" :closed="false" :comments="openQueriesComments" @back="hideOpenQueryDetails" @replyQuery="replyQuery" @closeQuery="closeQuery" :queryId="openQueryId" :userRoles="userRoles" :selectedQuestionId="selectedQuestionId" />
              </div>
            </div>
          </div>

          <div v-else class="pt-25 pl-32">
            <span class="d-block">No queries created yet</span>
            <span class="d-block">Select a field to create a query</span>
          </div>
        </template>
      </b-tab>

      <b-tab :title="`Closed Queries: ${noOfClosedQueries}`" :title-link-class="'tabs-details'">
        <div class="filter-container d-flex justify-content-between p-7 fs-12" v-if="selectedQuestionId && !closedQueryId">
          Filtered by field ID {{ selectedQuestionId }}
          <span class="clear-filter-text" @click="clearFilter">Clear</span>
        </div>
        <div v-if="closedQueries && closedQueries.length">
          <div class="partipant-response-open-queries-container queries-container">
            <div v-if="!closedQueryId" class="pt-16">
              <ParticipantActivityResponseQueryItem v-for="query in closedQueries" :key="query.id" :query="query" @displayDetailedView="viewClosedQueryDetails" :queryId="closedQueryId" />
            </div>

            <div v-else>
              <ParticipantActivityResponseQueryDetails :lockStatus="lockStatus" :closed="true" :comments="closedQueriesComments" :queryId="closedQueryId" @back="hideClosedQueryDetails" @reopenQuery="reopenQuery" :userRoles="userRoles" />
            </div>
          </div>
        </div>
        <div v-else class="pt-25 pl-32">
          <span class="d-block">No queries closed yet</span>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import ParticipantActivityResponseQueryDetails from "@/components/participants/activity-response/participant-activity-response-query-details";
import ParticipantActivityResponseQueryItem from "@/components/participants/activity-response/participant-activity-response-query-item";

export default {
  name: "participant-activity-response-queries",

  components: {
    ParticipantActivityResponseQueryDetails,
    ParticipantActivityResponseQueryItem
  },

  data() {
    return {
      isDisplayCreateQueryBtn: true,
      openQueryText: "",
      isDisplayQueryDetailView: false,
      selectedQuery: null,
      openQueryId: null,
      closedQueryId: null,
      isCreateQueryBtnDisabled: false
    };
  },

  props: {
    surveyId: {
      type: String
    },
    revisionId: {
      type: String
    },
    studyId: {
      type: String
    },
    surveyResponseTrackerId: {},
    queries: {
      type: [Array, null]
    },
    selectedQuestionId: {
      type: [String, null]
    },
    isQueryInEditMode: {
      type: Boolean
    },
    activityQueries: {},
    userDetails:{},
    userRoles: {},
    participantId: {},
    lockStatus: String
  },

  watch: {
    selectedQuestionId() {
      this.openQueryId = null;
      this.closedQueryId = null;
      this.openQueryText = "";
    },
    isQueryInEditMode() {
      this.openQueryText = "";
    }
  },

  computed: {
    user() {
      return this.$store.getters["user"];
    },

    userFirstLastName() {
      let fullName = "";
      if (this.userDetails && this.userDetails.firstName) {
        fullName += this.userDetails.firstName;
      }

      if (this.userDetails && this.userDetails.lastName) {
        fullName += " " + this.userDetails.lastName;
      }

      return fullName;
    },

    openQueries() {
      if (!this.activityQueries) {
        return null;
      }

      if (!this.selectedQuestionId) {
        return this.activityQueries.filter(query => {
          if (query.status === 0) {
            return true;
          }
          return false;
        });
      }

      const openQueries = [];
      Object.values(this.queries).forEach(query => {
        if (query.status == 0) {
          openQueries.push(query);
        }
      });
      return openQueries;
    },

    openQueriesComments() {
      if (!this.openQueryId || !this.openQueries) {
        return [];
      }

      const query = this.openQueries.find(query => query.id === this.openQueryId);
      if (!query) {
        return [];
      }

      return query.replies;
    },

    closedQueriesComments() {
      if (!this.closedQueryId || !this.closedQueries) {
        return [];
      }

      const query = this.closedQueries.find(query => query.id === this.closedQueryId);
      if (!query) {
        return [];
      }

      return query.replies;
    },

    closedQueries() {
      // if (!this.queries) return null;

      if (!this.activityQueries) {
        return null;
      }

      if (!this.selectedQuestionId) {
        return this.activityQueries.filter(query => {
          if (query.status === 1) {
            return true;
          }
          return false;
        });
      }

      const closedQueries = [];
      Object.values(this.queries).forEach(query => {
        if (query.status == 1) {
          closedQueries.push(query);
        }
      });
      return closedQueries;
    },

    noOfOpenQueries() {
      if (this.openQueries && this.openQueries.length > 0) {
        return this.openQueries.length;
      }
      return 0;
    },

    noOfClosedQueries() {
      if (this.closedQueries && this.closedQueries.length > 0) {
        return this.closedQueries.length;
      }
      return 0;
    }
  },

  methods: {
    postNewQuery() {
      if (!this.veeFields.openQueryText.valid) {
        return;
      }

      const requestBody = {
        questionId: this.selectedQuestionId,
        studyId: this.studyId,
        issuer: this.userFirstLastName,
        issuerRole: this.user.userRole,
        createdBy: this.userFirstLastName,
        queryContent: this.openQueryText,
        status: 0,
        surveyResponseTrackerId: this.surveyResponseTrackerId,
        userId: this.user.id,
        modified_by: this.userFirstLastName
      };

      this.isCreateQueryBtnDisabled = true;
      this.$api
        .postNewSurveyResponseQuery(this.surveyId, this.revisionId, this.participantId, requestBody)
        .then(() => {
          this.$emit("postNewQuery");
          this.isDisplayCreateQueryBtn = true;
          this.openQueryId = null;
          this.isCreateQueryBtnDisabled = false;
          this.$toastr.success("Query created successfully.");
        })

        .catch(() => {
          this.$toastr.error("Error while creating field query");
          this.isCreateQueryBtnDisabled = false;
        });
    },
    cancelCreatingANewQuery() {
      this.openQueryText = "";
      this.$emit("cancelCreateQuery");
    },
    isQuestionHasOpenQuery(questionId) {
      if (!this.queryDataObj[questionId]) {
        return false;
      }
      return true;
    },
    getQueriesForAQuestionById(questionId) {
      if (!questionId) {
        return [];
      }
      if (!this.isQuestionHasOpenQuery) {
        return [];
      }

      return this.queryDataObj[questionId];
    },
    displayDetailedView(query) {
      this.isDisplayQueryDetailView = true;
      this.selctedQuery = query;
    },
    replyQuery(queryDetails) {
      const requestBody = {
        query_id: queryDetails.queryId,
        issuer: this.userFirstLastName,
        issuer_role: this.user.userRole,
        created_by: this.userFirstLastName,
        notes: queryDetails.queryText,
        userId: this.user.id,
        modified_by: this.userFirstLastName,
        studyId: this.studyId
      };
      this.$api
        .postNewSurveyResponseQueryReplies(this.surveyId, this.revisionId, this.participantId, requestBody)
        .then(() => {
          this.$emit("refreshQueries");
        })
        .catch(() => {
          this.$toastr.error("Error while creating comment");
        });
    },

    closeQuery(queryDetails) {
      const requestBody = {
        question_id: this.selectedQuestionId,
        query_id: queryDetails.queryId,
        modified_by: this.userFirstLastName,
        studyId: this.studyId,
        userId: this.user.id,
        status: 1
      };
      this.$api
        .updateSurveyResponseQueryStatus(this.surveyId, this.revisionId, this.participantId, requestBody)
        .then(() => {
          this.$emit("refreshQueries");
          this.openQueryId = null;
          this.$toastr.success("Query closed successfully.");
          this.clearFilter();
        })
        .catch(() => {
          this.$toastr.error("Error while closing query");
        });
    },

    reopenQuery(queryDetails) {
      const requestBody = {
        question_id: this.selectedQuestionId,
        query_id: queryDetails.queryId,
        status: 0,
        modified_by: this.userFirstLastName,
        studyId: this.studyId,
        userId: this.user.id
      };

      this.$api
        .updateSurveyResponseQueryStatus(this.surveyId, this.revisionId, this.participantId, requestBody)
        .then(() => {
          this.$emit("refreshQueries");
          this.closedQueryId = null;
          this.$toastr.success("Query reopened successfully.");
          this.clearFilter();
        })
        .catch(() => {
          this.$toastr.error("Error while reopening query");
        });
    },
    onDisplayDetailedView(query) {
      this.isDisplayQueryDetailView = true;
      this.selectedQuery = query;
    },
    viewOpenQueryDetails(query) {
      if (!this.selectedQuestionId) {
        this.$emit("onChangeQuestionId", query.question_id);
      } else {
        this.openQueryId = query.id;
      }
    },

    clearFilter() {
      this.$emit("onChangeQuestionId", null);
    },
    viewClosedQueryDetails(query) {
      if (!this.selectedQuestionId) {
        this.$emit("onChangeQuestionId", query.question_id);
      } else {
        this.closedQueryId = query.id;
      }
    },
    hideOpenQueryDetails() {
      this.clearFilter();
      this.openQueryId = null;
    },
    hideClosedQueryDetails() {
      this.clearFilter();
      this.closedQueryId = null;
    }
  }
};
</script>

<style scoped lang="scss">
.queries-container {
  max-height: 70vh;
  overflow: auto;
}

button {
  outline: none;
}

.field-query-container {
  position: absolute;
  left: 0;
  width: 100%;
  top: 35%;
}

.bgf9f9fb {
  background-color: #f9f9fb;
}

.create-query-btn-container {
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 32px;
}

.create-new-query-form-container {
  height: 250px;

  textarea {
    &::-webkit-input-placeholder {
      /* Edge */
      color: #b0bac9;
    }

    &:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #b0bac9;
    }

    &::placeholder {
      color: #b0bac9;
    }
  }
}

.post-query-btn {
  color: white;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  width: 119px;
  height: 35.3px;
  border-radius: 3px;
  border: solid 1px #ffffff;
  background-color: #4c8ce4;
  cursor: pointer;
}

.cancel-post-query-btn {
  background-color: transparent;
  color: #000000;
  font-size: 14px;
  border: none;
  cursor: pointer;
}

.filter-container {
  background-color: rgba(211, 223, 228, 0.5);
}

.clear-filter-text {
  text-decoration: underline;
  cursor: pointer;
}
</style>
